import { CUBE_CAMERA_FAR_ITEM, CUBE_CAMERA_NEAR_ITEM, CUBE_CAMERA_RESOLUTION_3D } from '@constants'
import { CubeCamera } from '@react-three/drei'
import { createContext, useContext } from 'react'

// El contexto ahora incluye el renderTarget
const CubeCameraContext = createContext(null)

export function CubeCameraProvider({ children }) {
  // El render prop inyecta el renderTarget en el contexto
  return (
    <CubeCamera
      name='shared-cube-camera'
      frustumCulled
      near={CUBE_CAMERA_NEAR_ITEM}
      far={CUBE_CAMERA_FAR_ITEM}
      resolution={CUBE_CAMERA_RESOLUTION_3D}
    >
      {(renderTarget) => (
        <CubeCameraContext.Provider value={{ renderTarget }}>{children}</CubeCameraContext.Provider>
      )}
    </CubeCamera>
  )
}

export function useSharedCubeCamera() {
  return useContext(CubeCameraContext)
}
